import React from 'react'
import DefaultComponentLayout, { LayoutContent } from '../common/Layout'
import I18nMessage from '../common/I18nMessage'
import './VerificationDeclined.scss'

function VerificationDeclined() {
  return (
    <DefaultComponentLayout nameSpace="parent-verify__declined">
      <LayoutContent title message="passport.coppa.text.coppa" />
      <LayoutContent main>
        <I18nMessage id="passport.coppa.declined.notice" />
      </LayoutContent>
    </DefaultComponentLayout>
  )
}

VerificationDeclined.propTypes = {
}

export default VerificationDeclined
